import Select, {ISelectItem} from "../../../1. Core/Controls/Select/Select";
import IconSelectItem from "./IconSelectItem";
import NP from "../../../1. Core/NP";

export interface IIconSelectItem extends ISelectItem {
	FontImage: string
}

export interface IIconSelectItemArgs {
	Item: IIconSelectItem;
}

export default class IconSelect extends Select {

	constructor(settings?: object)
	{
		super(settings);
	}

	_initFields(settings: object)
	{
		super._initFields(settings);
		this._CustomInput = new IconSelectItem({
			ParentNode: this._root,
		});
	}

	_render()
	{
		super._render();
		this._selectInput = NP.createNode(this._selectInputContainer, 'icon-select__native-control', 'select', this._selectInputOutline);
		this.setItems(this._Items, false);

		if (this._SelectedIndex > -1)
			this.setSelectedIndex(this._SelectedIndex, false);

		this._selectInput.addEventListener('change', () =>
		{
			this.setSelectedItem(this._Items[this._selectInput.selectedIndex] as IIconSelectItem);
		});
		this._selectInput.addEventListener('blur', () =>
		{
			this.setActive(false);
			this.EvBlur.fire(this)
		});
		this._selectInput.addEventListener('focus', () =>
		{
			this.setActive(true);
			this.EvFocus.fire(this)
		});
	}

	setSelectedItem(item: IIconSelectItem, fireEvent?: boolean)
	{
		if (item)
		{
			this._Value = item.Value;
			this._selectInput.value = item.Value;
			this._SelectedItem = item;
			(this._CustomInput as IconSelectItem).refresh(item);
			if (fireEvent !== false)
				this.EvItemSelected.fire(this, {Item: item});
		}
	}

	setValue(value: any, fireEvent?: boolean)
	{
		this.setSelectedItem(this.getItem(value) as IIconSelectItem, fireEvent)
	}
}